<app-menu-toggle
  tooltip="Histogram panel"
  icon="histogram"
  [active]="showHistogram"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
